<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 2/9/2020
  -->

<template>
	<div class="card form-element-root" v-bind="attrsStylesClass">
		<el-form-item
			:prop="prop"
			:rules="rules">

			<slot name="content">
				<div v-show="isTitleElement"
					 class="horizontal-line"/>
				<div v-show="isFooterElement"
					 class="horizontal-line-bottom"/>


				<div class="px-4 relative" :class="{'pt-4': !isEditMode}"
					 style="padding-bottom: 0!important;" @mouseup="onElementSelected">
					<div class="qwoach-form show-on-hover-parent">

						<div v-if="isEditMode">

							<div class="absolute hide-on-print" style="right: 20px;">
								<slot name="hint">
									<div v-if="isSpecialFormElement">
										Smart Question
										<ToolTipView :analyticsProps="tooltipAnalyticsProps">
											This is a smart question that will collect {{ formElement.getSpecialQuestionDescription() }}.
											<br/><br/>
											It will only be collected once and this field will be hidden automatically for those whose {{formElement.getSpecialQuestionDescription()}} is known.
<!--											<br/><br/>-->
<!--											You can optionally adjust what your clients see as a question for this field.-->
										</ToolTipView>
									</div>
								</slot>
							</div>
						</div>
						<div v-if="isEditMode && isEditable" class="drag-handle text-center cursor-move hide-on-print-invisible"
							 :class="{'show-on-hover-item' : !isSelected}">
							<i class=" fontello icon-menu"/>
						</div>
						<div v-else-if="isEditMode && !isEditable" class="py-3"></div>
						<!--  v-if resets focus on first click which requires another
						  --  click to start typing, so using v-show here instead
						  -->
						<div v-show="isSelected"
							 class="is-selected absolute hide-on-print"
							 style="left: 0; top: 0; bottom: 0;"/>
						<div class="row mx-0 mb-2 align-items-center">
<!--							there is a problem where long title is shrinked when flex-basis:0 when title is span ie readonly
								but when 'flex-basis: auto' and and title is input it is width becomes 100% wich pushes out "select type" element.
								this is a hack. You are welcome to investigate it and fix it properly.
 -->
							<div class="col px-0" :style="{'flex-basis': isReadonlyComputed ? 'auto':  0}">
								<slot name="title">
									<div>
										<FormTextRow
											ref="title"
											v-if="isSelected || !formElement.isRequired"
											class="form-title"
											:class="{'pl-0': isReadonlyComputed}"
											:addBottomMargin="false"
											v-model="formElement.title"
											:showDivider="isSelected"
											:readonly="isReadonlyComputed"
											:multiline="true"
											:required="true"
											:placeholder="isEditMode ? (titlePlaceholder || formElement.placeholder) : ''"
											@input="inputChangedDebounced"
											@blur="inputChanged"
										/>
										<div v-else-if="formElement.title"
											 class="form-padding"
											 style="line-height: 1.6;"
											 @mouseup="onTitleSpanClicked()">
											<span class="form-title">{{ formElement.title }}</span>
											<span v-if="formElement.isRequired && !hideAsterisk" class="text-danger hide-on-print">&nbsp;*</span>
										</div>
									</div>

								</slot>
							</div>
							<div class="qwoach-form" style="min-width: 250px;">
								<FormElementTypeSelect
									v-if="isSelected && formElement.showTypeSelect"
									class="input-background ml-3 hide-on-print"
									:is-disabled-fn="isDisabledType"
									v-model="formElement.type"
									@change="onTypeChanged"/>
							</div>
						</div>
						<div v-if="!hideDescription && isReadonlyComputed"
							 v-html="formElement.description"
							 class=" mb-3 text-muted"
							 style="line-height: 1.3em;"
						/>

						<FormTextRow
							v-else-if="!hideDescription && (isEditMode && isSelected && formElement.showDescription || formElement.description)"
							class="form-description mb-2 text-muted"
							:class="{'pl-0': isReadonlyComputed}"
							v-model="formElement.description"
							:readonly="isReadonlyComputed"
							:showDivider="isSelected"
							:multiline="true"
							placeholder="Description (optional)"
							@input="inputChangedDebounced"
							@blur="inputChanged"
						/>

						<!--					<slot v-if="!isSpecialFormElement || !isEditMode" name="body"/>-->
						<slot name="body"/>
						<FormElementMenu
							v-if="isSelected"
							class="hide-on-print"
							:formElement="formElement"
							:hideRequired="menuHideRequired || !formElement.showRequiredSwitch"
							@copy="onCopyClicked"
							@delete="onDeleteClicked"
							@descriptionVisibilityToggle="descriptionVisibilityToggle"
							@onRequiredChanged="notifyElementChanged"
							@scoringDirectionToggle="scoringDirectionToggle"
							@change="notifyElementChanged">
							<template #menuOptionsLeft>
								<slot name="menuOptionsLeft"></slot>
							</template>

						</FormElementMenu>
						<div v-else-if="isEditMode" class="pb-5"/>
					</div>
				</div>
			</slot>

		</el-form-item>
	</div>

</template>

<script>
import BaseFormElement from "@/core/modules/coach/Resources/Forms/FormElements/BaseFormElementView.vue";
import FormElementTypeSelect
	from "@/core/modules/coach/Resources/Forms/FormElements/HelperElements/FormElementTypeSelect.vue";
import FormElementMenu from "@/core/modules/coach/Resources/Forms/FormElements/HelperElements/FormElementMenu.vue";
import FormTextRow from "@/core/components/Form/FormTextRow.vue";
import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";
import FormElementTitle from "@/core/modules/coach/Resources/Forms/model/FormElements/Additional/FormElementTitle";
import FormElementFooter from "@/core/modules/coach/Resources/Forms/model/FormElements/Additional/FormElementFooter";

export default {
	name: "FormElementTemplate",
	components: {ToolTipView, FormTextRow, FormElementMenu, FormElementTypeSelect},
	extends: BaseFormElement,
	inheritAttrs: false,

	props: {
		prop: null,
		rules: null,
		titlePlaceholder: String,
		menuHideRequired: Boolean,
		hideDescription: Boolean,
		hideType: Boolean,
		hideMenu: Boolean,
		hideDragHandle: Boolean,
		tooltipAnalyticsProps: Object,
		hideAsterisk: Boolean,
		disabledTypes: Array,
	},

	methods: {
		onTitleSpanClicked() {
			console.log("onTitleSpanClicked")
			setTimeout(() => {
				this.$nextTick(() => {
					if (this.$refs.title) {
						this.$refs.title.focus()
					}
				})
			}, 200)
		},

		isDisabledType(element){
			console.log("FormElementTemplate.isDisabledType element = ", element, ", this.disabledTypes = ", this.disabledTypes)
			return this.disabledTypes && this.disabledTypes.includes(element.value)
		},

	},

	computed: {

		isTitleElement() {
			return this.formElement instanceof FormElementTitle
		},

		isFooterElement() {
			return this.formElement instanceof FormElementFooter
		},

		isReadonlyComputed() {
			return !this.isEditMode || !this.isSelected
		}
	}
}
</script>

<style lang="scss">

.form-element-root {
	.el-form-item__error {
		padding-top: 10px;
		padding-left: 22px;
	}

	.el-form-item {
		margin-bottom: 10px;
	}

	.el-form-item.is-error {
		margin-bottom: 36px;
	}

}

</style>
